import React, { Component } from "react";
import { Row, Col, Card } from "antd";
import withRouter from "../withRouter";
import { StoreContext } from "../store/RootStore";
import { observer } from "mobx-react";
import Cookies from "universal-cookie";

import advanceDashboardIcon from "../assets/images/awtllaunchingdashboard/advance-dashboard.png";
import maintenanceIcon from "../assets/images/awtllaunchingdashboard/mentainance-dashboard.png";
import alertsIcon from "../assets/images/awtllaunchingdashboard/alerts.png";
import dashboardIcon from "../assets/images/awtllaunchingdashboard/dashboard.png";
import detailTrackingIcon from "../assets/images/awtllaunchingdashboard/detail-tracking.png";
import expirySoonIcon from "../assets/images/awtllaunchingdashboard/expiring-soon.png";
import helpIcon from "../assets/images/awtllaunchingdashboard/help.png";
import liveTrackingIcon from "../assets/images/awtllaunchingdashboard/live-tracking.png";
import historyTrackingIcon from "../assets/images/awtllaunchingdashboard/history-tracking.png";
import mastersIcon from "../assets/images/awtllaunchingdashboard/masters.png";
import reportsIcon from "../assets/images/awtllaunchingdashboard/reports.png";
import videoMonitoringIcon from "../assets/images/awtllaunchingdashboard/video-monitoring.png";
//import bgVideo from "../assets/images/awtllaunchingdashboard/3597717219-preview.mp4";
import logoNew from "../assets/images/logoNew.jpg";
import logoutIcon from "../assets/images/awtllaunchingdashboard/logout.png";

import {
  DashboardOutlined,
  EnvironmentOutlined,
  BarChartOutlined,
  ClockCircleOutlined,
  FileSearchOutlined,
  SettingOutlined,
  BellOutlined,
  WarningOutlined,
  ToolOutlined,
  FileTextOutlined,
  VideoCameraOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";

const ICON_MAP = {
  advancedashboardClass: advanceDashboardIcon,
  livetrackingClass: liveTrackingIcon,
  dashboardClass: dashboardIcon,
  historytrackingClass: historyTrackingIcon,
  detailTrackingClass: detailTrackingIcon,
  mastersClass: mastersIcon,
  alertsClass: alertsIcon,
  expirySoonClass: expirySoonIcon,
  maintenanceClass: maintenanceIcon,
  reportsClass: reportsIcon,
  videoMonitorClass: videoMonitoringIcon,
  helpClass: helpIcon,
};

class Proawtlawtllaunchingdashboard extends Component {
  constructor(props) {
    super(props);

    this.cookies = new Cookies();
    this.rolePermission2 = JSON.parse(localStorage.getItem("rolePermission2"));

    this.state = {};
  }

  render() {
    return (
      <div
        className="cardContainer"
        style={{
          minHeight: "100vh",
          //background: "#bfc4c9",
        }}
      >
        <div className="logOutContainer">
          <img
            src={logoutIcon}
            alt="Logout"
            onClick={this.props.handleLogout}
            style={{
              width: 28,
              height: 28,
              cursor: "pointer",
              opacity: 0.9,
            }}
          />
        </div>
        <Row gutter={[24, 24]} justify="center">
          {this.props.features.map((item, index) => {
            let canView = this.rolePermission2[item.url]?.canView;
            if (
              item.class === "expirySoonClass" &&
              this.rolePermission2?.vehiclelist?.canView === 0
            ) {
              canView = 0;
            } else if (item.class === "expirySoonClass") {
              canView = 1;
            }

            if (item.class === "helpClass") {
              canView = 1;
            }

            return (
              <Col key={index} xs={24} sm={12} md={8} lg={4}>
                <Card
                  className={
                    !item.url || canView !== 1
                      ? "card-disabled"
                      : "ant-card-body"
                  }
                  hoverable={1}
                  onClick={() => {
                    if (item.url && canView === 1) {
                      this.props.updateDashboard(item.url, 0);
                    }
                  }}
                  bodyStyle={{
                    padding: "24px 18px",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: item.description ? "flex-start" : "center",
                  }}
                  style={
                    {
                      //   minHeight: 270,
                      //height: "100%",
                    }
                  }
                >
                  {/* ICON */}
                  <div
                    style={{
                      height: 48,
                      marginBottom: 14,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img src={ICON_MAP[item.class]} />
                  </div>

                  {/* TITLE */}
                  <div
                    className="cardInfo"
                    style={{
                      fontSize: 15,
                      fontWeight: 600,
                      marginBottom: 10,
                      lineHeight: "18px",
                    }}
                  >
                    <h1>{item.title}</h1>
                    <p> {item.description}</p>
                    {item.class === "helpClass" && (
                      <div className="contact">
                        <p>
                          <i class="bi bi-whatsapp"></i>
                          +966115003419
                        </p>
                        <p>
                          {" "}
                          <i class="bi bi-telephone"></i>
                          +966115003419
                        </p>
                      </div>
                    )}
                  </div>

                  {/* DESCRIPTION */}
                  {/* <div
                  style={{
                    fontSize: 12,
                    lineHeight: "18px",
                    color: "#cbd5e1",
                  }}
                >
              
                </div> */}
                </Card>
              </Col>
            );
          })}
        </Row>
      </div>
    );
  }
}

Proawtlawtllaunchingdashboard.contextType = StoreContext;
export default observer(withRouter(Proawtlawtllaunchingdashboard));
